// Live's words on a failed generation (#252 item 6; LEFTOVERS G1, colortv-web
// `constants/images.tsx` and `constants/videos.tsx`): "Oops! We couldn’t generate this image."
// or "…video.", then the job's error, else live's sentence on the provider's refusal. Live has
// none for sounds and texts, so those keep ours.

const IMAGE_REFUSAL =
  "The AI provider flagged it due to possible content restrictions (like nudity or violence), or occasionally for unclear reasons. Try again with a slightly different prompt.";
const VIDEO_REFUSAL =
  "The AI provider flagged it due to possible content restrictions, or occasionally for unclear reasons. Try again with a slightly different prompt.";

export interface FailedWords {
  title: string;
  description: string;
}

/** The failed box's words for a job of `type` (`image.simple`, `video.text`…) and its error. */
export function failedWords(type: string, message: string | undefined): FailedWords {
  const said = message === undefined || message.trim() === "" ? undefined : message;
  if (type === "image.layerize") {
    // Live's Layerize words (its generation card's failure).
    return {
      title: "Layer separation failed",
      description: "The image could not be separated into layers. Try a different image.",
    };
  }
  if (type.startsWith("image.")) {
    return { title: "Oops! We couldn’t generate this image.", description: said ?? IMAGE_REFUSAL };
  }
  if (type.startsWith("video.")) {
    return { title: "Oops! We couldn’t generate this video.", description: said ?? VIDEO_REFUSAL };
  }
  return { title: "The job did not finish", description: said ?? "" };
}
